<template>
  <v-card class="card px-3">
    <div class="header px-3 pt-4 mb-4 layout no-wrap align-center">
      <div class="title">
        Assign Reference
      </div>
      <v-spacer />
      <core-input :prepend-icon="icons.search" label="Search References" @keydown="e => (search = e)" />
    </div>
    <references :search-prop="search" selectable :selected="preselected" @changed-selection="onChange" />
    <v-spacer />

    <v-card-actions class="actions" style="max-height: 52px;">
      <v-chip color="primary" small class="mr-2">
        {{ selected.length }}
      </v-chip>
      References selected
      <v-spacer />

      <v-btn depressed @click="close">
        Close
      </v-btn>
      <v-btn :loading="loading" color="primary" depressed @click="onSubmit">
        Add
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import References from '@/components/resources/references';
import { ASSIGN_REFERENCES } from '@/config/constants';
import CoreInputVue from '../core/inputs/CoreInput.vue';
import icons from '../../mixins/icons';
import { EventBus } from '../../event-bus';

export default {
  name: 'ReferenceAssignDialog',
  components: { References, coreInput: CoreInputVue },
  mixins: [icons],
  props: {
    preselected: Array
  },
  data() {
    return {
      selected: [],
      loading: false,
      search: null
    };
  },
  watch: {
    // 'preselected'(val) {
    //   this.selected = val;
    // }
  },
  methods: {
    onChange(e) {
      this.selected = e;
    },
    close() {
      this.$emit('close');
    },
    onSubmit() {
      this.loading = true;
      this.$emit('submit-references', this.selected);
      this.selected = [];
      this.loading = false;
      this.close();
      // EventBus.$emit('update-reference', this.$route.query.asset);
      // this.$store.dispatch(ASSIGN_REFERENCES, this.selected).then(() => {

      // });
    }
  }
};
</script>

<style scoped>
.card {
  width: 700px;
  margin: 0 auto;
}
.actions {
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: white;
  border-top: 1px solid var(--light-form-bg) !important;
}
.header {
  position: sticky;
  width: 100%;
  height: 100px;
  top: 0;
  z-index: 1000;
  background-color: white !important;
}
.title {
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  max-height: 35px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}
</style>
